import { createLink } from '@tanstack/react-router';

import { MenuLinkItem } from '@creditornot/cb-menu';

export const ReactRouterMenuLinkItem = createLink(MenuLinkItem);
